import React from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './dashboard';
import ExecutiveSummary from './ExecutiveSummary';
import CarbonLifecycleDashboard from './CarbonLifecycleDashboard';
import { REPORT_PATH } from '../constant/reportType';
import { Card } from 'antd';

const DashboardPages = () => {
    const { reportType } = useParams();

    const renderContent = () => {
        switch (reportType) {
            case REPORT_PATH.EXECUTIVE_SUMMARY:
                return <ExecutiveSummary />;
            case REPORT_PATH.DASHBOARD_CARBON:
            default:
                return <CarbonLifecycleDashboard />;
        }
    };

    return (
        <div className="w-100">
            {renderContent()}
        </div>
    );
};

const PlaceholderPage = ({ title }: { title: string }) => {
    return (
        <div className="bg-white px-3 rounded">
            <div className="d-flex justify-content-between">
                <div>
                    <h2 className="pt-3 text-accent fw-bold mb-0 text-start">{title} Dashboard</h2>
                    <p className="text-muted text-start fs-6">Data module for {title}</p>
                </div>
            </div>
            <div className="mt-4 pb-5">
                <Card bordered={false}>
                    <div className="text-center py-5">
                        <h4 className="text-muted">Module Under Construction</h4>
                        <p>The {title} dashboard is currently being set up.</p>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default DashboardPages;
